// extracted by mini-css-extract-plugin
module.exports =  {"footer":"a10a3f92e9--footer--nhS3b","mobile":"a10a3f92e9--mobile--Oyj6T","button":"a10a3f92e9--button--V3dK1"};